import React from 'react';
import { ExcelTableCellProps } from '../../TableCell';
import { WeaBrowser, WeaLocaleProvider } from 'ecCom';
import { message } from 'antd';
import { observer } from 'mobx-react';
import { getDomIdByFieldKey } from '../../../../util/typeUtil';
import { toJS } from 'mobx';
import window from '../../../../util';
import { modeForm } from '../../../../util/excelUtil';
import { getContentPath } from '../../../../util/contentPath';
import { WeaTools } from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

@observer
export default class Browser extends React.Component<ExcelTableCellProps, any> {
    constructor(props) {
        super(props);
        this.state = {
            sapBrowserPro: {}
        }
    }
    openFullWindow = (url) => {
        const width = screen.availWidth - 10;
        const height = screen.availHeight - 50;
        let szFeatures = 'top=0,';
        szFeatures += 'left=0,';
        szFeatures += `width=${width},`;
        szFeatures += `height=${height},`;
        szFeatures += 'directories=no,';
        szFeatures += 'status=yes,toolbar=no,location=no,';
        szFeatures += 'menubar=no,';
        szFeatures += 'scrollbars=yes,';
        szFeatures += 'resizable=yes';
        window.open(url, '', szFeatures);
    }

    addOnClick = () => {
        const { cell, form ,card} = this.props;
        const path = cell.getPath();
        const bindObj = form.$(path);
        const fieldMark = getDomIdByFieldKey(bindObj.path);
        let secretLevel = 4;
        let seclevelInfo = card.seclevelInfo;
        if( seclevelInfo !=undefined && seclevelInfo !="-1"){
            if( modeForm.getCurrentModeStore().cubeForm.$(seclevelInfo).values() !=''){
                secretLevel =   modeForm.getCurrentModeStore().cubeForm.$(seclevelInfo).values();
            }
        }
       
        window.__createDocFn = function (o) {
            var fieldvalueobj = window.ModeForm.getFieldValueObj(fieldMark) || {};
            var old_docids = fieldvalueobj.value || '';
            var old_docspecialobj = toJS(fieldvalueobj.specialobj) || [];
            old_docspecialobj.push({ id: o.docid, name: o.docSubject })
            var new_fieldvalueobj = {
                value: old_docspecialobj.length > 0 && old_docids != '' ? old_docids + ',' + o.docid : o.docid,
                specialobj: old_docspecialobj,
                _secretLevel:secretLevel
            };
            window.ModeForm.changeFieldValue(fieldMark, new_fieldvalueobj);
        };
        this.openFullWindow(getContentPath('/spa/document/static/index.html#/main/document/add?openNewWindow=0&moudleFrom=cube&_secretLevel='+secretLevel));
    };

    sapBrowserChange = (ids, names, datas) => {
        const { fieldid, fielddbtype, isdetail, detailRowIndex } = this.state.sapBrowserPro;
        let params = { fieldid, fielddbtype, datas: JSON.stringify(datas), fromNodeorReport: 0, requestid: -1 }
        if (ids == '') {
            return;
        }
        WeaTools.callApi('/api/SapIntegration/browser/assignToBill', 'POST', params).then(result => {
            let fieldsValueMap = result.datas[0];
            Object.keys(fieldsValueMap).forEach(function (key) {
                try {
                    window.ModeForm.changeFieldValue(key, fieldsValueMap[key]);
                    if (isdetail) {
                        window.ModeForm.changeFieldValue(key + '_' + detailRowIndex, fieldsValueMap[key]);
                    }
                } catch (e) { }
            });
        });
    }
    render() {
        const { cell, form, card, className, excel } = this.props;
        const path = cell.getPath();
        const bindObj = form.$(path);
        const fieldName = getDomIdByFieldKey(bindObj.path);
        const bind = bindObj.bind();
        const { quickEditStore,getDetailFormValues } = card;
        const { viewAttr: _viewAttr, isEdit, isMandatory } = bind;
        let hasAdvanceSerach = true;
        const { fieldtype, isdetail, expendattr, sqlNeedFieldKey } = card.getFieldProps(path);
        let browserProps = bind.browserProps || card.getFieldProps(path).browserProps;
        const tabs= bind.tabs || card.getFieldProps(path).tabs||[];
        let secretLevel = '';
        let seclevelInfo = card.seclevelInfo;

        if( seclevelInfo !=undefined && seclevelInfo !="-1"){
            if( modeForm.getCurrentModeStore().cubeForm.$(seclevelInfo).values() !=''){
                secretLevel =   modeForm.getCurrentModeStore().cubeForm.$(seclevelInfo).values();
            }
        }

        if(tabs.length>0){
            browserProps = {...browserProps,tabs:toJS(tabs)}
        }
        let viewAttr = _viewAttr ? _viewAttr : (isMandatory ? 3 : (isEdit ? 2 : 1));
        if (excel.detailProps && excel.detailProps.hasOwnProperty("isEdit") && card.params.type == '2') {
            //如果明细表字段，设置了不可编辑已有明细,则已有明细不可编辑，但新增的明细可以编辑
            if (getDetailFormValues(form).dtl_id && !excel.detailProps["isEdit"]) {
                viewAttr = 1;
            }
        }
        const showDropMenu = fieldtype == '4' || fieldtype == '164';//部门分部显示维度菜单
        let hasAddBtn = false;//多文档显示新建文档按钮
        if (viewAttr != '1') {
            hasAddBtn = fieldtype == '37' && (card.base.type == '1' || card.base.type == '2');
        }
        const otherProps: any = {};
        if (fieldtype == '141') {
            otherProps.onChange = (_, __, datas) => {
                bindObj.onChange(spellResourceCondition(datas), __, datas);
            }
        }
        if (fieldtype == '17' && !isdetail) {
            browserProps.hasAddGroup = true;
        }

        if (fieldtype == '1' || fieldtype == '17') {
            browserProps.isShowGroup = !isdetail;
        }
        let relateFieldid = browserProps.relateFieldid;
        let completeParams = browserProps.completeParams || {};
        let dataParams = bind.dataParams || browserProps.dataParams || {};
        let destDataParams = bind.destDataParams || browserProps.destDataParams || {};
        if (fieldtype == '4' || fieldtype == '57' || fieldtype == '164' || fieldtype == '169' || fieldtype == '194' || fieldtype == '167' || fieldtype == '170' || fieldtype == '168') {   //部门，多部门，分部，多分部，单点分权，分权单部门，分权多分部，分权多部门
            dataParams = { ...dataParams, fromModule: "model","secretLevel": secretLevel };
            destDataParams = { ...dataParams, fromModule: "model" };
            completeParams = { ...completeParams, fromModule: "model","secretLevel": secretLevel };
        }
        if (fieldtype == '165' || fieldtype == '166' || fieldtype == '167' || fieldtype == '168' || fieldtype == '169' || fieldtype == '170') {//分权单人力资源，分权多人力资源，分权单部门，分权多部门，分权单分部，分权多分部
            dataParams = { ...dataParams, fromModule: "model", fieldid: path.replace("field", ""), isbill: "1", viewtype: isdetail ? 1 : 0 };
            destDataParams = { ...dataParams, fromModule: "model", fieldid: path.replace("field", ""), isbill: "1", viewtype: isdetail ? 1 : 0 };
            completeParams = { ...completeParams, fromModule: "model", fieldid: path.replace("field", ""), isbill: "1", viewtype: isdetail ? 1 : 0,"secretLevel": secretLevel };
        }
        let conditionDataParams = browserProps.conditionDataParams || {};   
        let parm ={
            isFromMode:"1",
            modeId:card.base.modeId,
            fieldid:path.replace("field",""),
            isbill:1,
            viewtype: isdetail ? "1" : "0",
            };
        dataParams = { ...dataParams, ...parm,"secretLevel": secretLevel};  
        conditionDataParams ={...conditionDataParams,...parm};
        completeParams = { ...completeParams, ...parm,"secretLevel": secretLevel };    
        //let disabledInput = false;
        if (fieldtype == '161' || fieldtype == '162') {
            const formData = card.getDataParamsForSql(path, form, sqlNeedFieldKey);
            dataParams = { ...dataParams, ...formData,"secretLevel": secretLevel };
            conditionDataParams = { ...conditionDataParams, ...formData };
            completeParams = { ...completeParams, ...formData ,"secretLevel": secretLevel };
            // con26705_value: 8      con浏览框查询条件字段id
            let relateFieldValues={};
            if(relateFieldid){
                relateFieldid.map(fieldid_=>{
                    const field = "field"+fieldid_.split("_")[0];
                    const fieldinfo = modeForm.getFieldInfo(field);
                    try{
                        if(fieldinfo.isdetail){
                            let detailRowIndex = form.path.split(".")[1];
                            relateFieldValues[field]=modeForm.getFieldValue(field+"_"+detailRowIndex);
                        }else{
                            relateFieldValues[field]=modeForm.getFieldValue(field);
                        }
                    }catch(e){
                        relateFieldValues[field]='';
                    }
                });       
            }
            dataParams={...dataParams,...relateFieldValues,"secretLevel": secretLevel};//field45270:"6"
            conditionDataParams={...conditionDataParams,...relateFieldValues};
            completeParams={...completeParams,...relateFieldValues,"secretLevel": secretLevel};      
        } else if (fieldtype == '256' || fieldtype == '257') {
            //disabledInput = true;//树形不支持快捷搜索
            const formData = card.getDataParamsForSql(path, form, sqlNeedFieldKey);
            dataParams = { ...dataParams, ...formData, selectedCount: (bind.valueObj&&bind.valueObj.length)  || 0,"secretLevel": secretLevel};
            //asynLoadAll为true时才自动展开节点,根据defaultExpandedLevel来决定展开的节点层数(如果树浏览框选择了值,默认展开10层,一般情况下应该够用了)
            //组件不支持递归调用自动全部展开,因此如果是11层的树,则最后一层不会自动展开
            // if (bind.valueObj.length > 0) {//如果树浏览框选择了值,则下次打开要展开所有层级
            //     browserProps['asynLoadAll'] = true;
            //     browserProps['defaultExpandedLevel'] = 10;
            // } else {
            //     if (browserProps.expandfirstnode) {//如果默认展开一级节点
            //         // browserProps['asynLoadAll'] = true;
            //         browserProps['defaultExpandedLevel'] = 1;
            //     }
            // }
            otherProps['asynLoadAll'] = false;
            hasAdvanceSerach = browserProps.hasAdvanceSerach;
            conditionDataParams = { ...conditionDataParams, ...formData };
            completeParams = { ...completeParams, ...formData ,"secretLevel": secretLevel};
            if (expendattr.startsWith("treerootnode")) {
                const key = expendattr.substring(expendattr.indexOf("=") + 1);
                const arr = key.split(",");
                let treerootnode = "";
                for (let i = 0, len = arr.length; i < len; i++) {
                    let tempKey = `${arr[i].substring(arr[i].indexOf("$") + 1, arr[i].lastIndexOf("$"))}_${dataParams.currenttime}`
                    if (dataParams[tempKey] != "" && dataParams[tempKey] != undefined) {
                        if (i != 0) {
                            treerootnode += ",";
                        }
                        treerootnode += dataParams[tempKey];
                    }

                }
                dataParams["treerootnode"] = treerootnode;
            }
        } else if (fieldtype == '226') {//sap 系统集成单选浏览按钮
            let relateFields = card.getFieldProps(path).relateFields.slice();
            let relateFieldValues = {};
            relateFields.map(v => {
                let field = 'field' + v.split("_")[0];
                try {
                    if (isdetail) {
                        let detailRowIndex = form.path.split(".")[1];
                        this.state.sapBrowserPro['detailRowIndex'] = detailRowIndex;
                        relateFieldValues[field] = modeForm.getFieldValue(field + "_" + detailRowIndex);
                    } else {
                        relateFieldValues[field] = modeForm.getFieldValue(field);
                    }
                } catch (e) {
                    relateFieldValues[field] = '';
                }
            });

            let sapOtherParams = { isbill: 1, rowIndex: isdetail ? 0 : -1 };
            sapOtherParams['fieldid'] = card.getFieldProps(path).fieldid;
            sapOtherParams['fielddbtype'] = card.getFieldProps(path).fielddbtype;
            sapOtherParams['billid'] = card.base.formId;
            sapOtherParams['issearch'] = true;

            dataParams = { ...dataParams, ...relateFieldValues, ...sapOtherParams };
            conditionDataParams = { ...conditionDataParams, ...relateFieldValues, ...sapOtherParams };
            completeParams = { ...completeParams, ...relateFieldValues, ...sapOtherParams };

            browserProps['onChange']=this.sapBrowserChange;//sap赋值动作
            this.state.sapBrowserPro['fieldid']=card.getFieldProps(path).fieldid;
            this.state.sapBrowserPro['rowIndex']=-1;
            this.state.sapBrowserPro['fielddbtype']=card.getFieldProps(path).fielddbtype;
            this.state.sapBrowserPro['isdetail']=isdetail;
        }else{
            let relateFieldValues={};
            if(fieldtype == '270'){//qc:985018
                bind.valueObj&&bind.valueObj.map((item)=>{
                    if(item.namespan){
                        item.namespan=item.name;
                    }
                });
            }
            if(relateFieldid){
            //    const fieldinfo = modeForm.getFieldInfo(fieldName);
            //    const rowIndex = fieldinfo.isdetail ? fieldName.split('_')[1] : '-1';
                relateFieldid.map(fieldid_=>{
                    const field = "field"+fieldid_.split("_")[0];
                    const fieldinfo = modeForm.getFieldInfo(field);
                    try{
                        if(fieldinfo.isdetail){
                            let detailRowIndex = form.path.split(".")[1];
                            relateFieldValues[field]=modeForm.getFieldValue(field+"_"+detailRowIndex);
                        }else{
                            relateFieldValues[field]=modeForm.getFieldValue(field);
                        }
                    }catch(e){
                        relateFieldValues[field]='';
                    }
                });       
            }
            dataParams={...dataParams,...relateFieldValues,"secretLevel": secretLevel};//field45270:"6"
            conditionDataParams={...conditionDataParams,...relateFieldValues};
            completeParams={...completeParams,...relateFieldValues,"secretLevel": secretLevel};         
        }
        // let iconStyle:any = {};
        /**
         * fieldtype == '161' || fieldtype == '162')
         * 这两个自定义单多选的浏览框是建模和系统集成两部分工用的，这里不好控制，云商店沟通确定了在处理
         */
        // if(fieldtype == '256' || fieldtype == '257'){  //自定义树形单多选浏览框图标可以用户自定义
            // iconStyle.icon = card.iconInfo.icon;
            // iconStyle.iconBgcolor =card.iconInfo.iconBg;
            // iconStyle.iconFontColor =card.iconInfo.iconColor;
        // }
        //前端自定义浏览框属性覆盖
        let overBrowserProps: any = {};
        let customBrowserProp = card.browserPropMap[fieldName] || {};
        for (let key in customBrowserProp) {
            overBrowserProps[key] = customBrowserProp[key];
        }
        let canQuickedit = bindObj.isquickedit && viewAttr == '1';
        //新增 显示模板的快编模式下 编辑模板中是否允许修改已有明细的判断
        if (canQuickedit && isdetail && !excel.detailProps["isEdit"]) {
            canQuickedit = false;
        }
		let isDisplay = '';
        if(!canQuickedit){
            isDisplay = 'none';
        }
        return (
            <div className={`${canQuickedit ? 'cube-card-editformitem ' : 'cube-card-editformitem2'} fieldValue ${className}`} data-fieldtype={fieldtype} data-fieldattr={viewAttr} data-fieldmark={fieldName}
                {...cell.cellProps}
                onClick={() => { canQuickedit && quickEditStore.lockEditFormItem(fieldName); }}
            >
                <div >
                    <WeaBrowser ecId={`${this && this.props && this.props.ecId || ''}_WeaBrowser@hp0ja1`}
                        {...bind}
                        {...browserProps}
                        dataParams={dataParams}
                        conditionDataParams={conditionDataParams}
                        destDataParams={destDataParams}
                        completeParams={completeParams}
                        hasAddBtn={hasAddBtn}
                        addOnClick={this.addOnClick}
                        layout={document.body}
                        showDropMenu={showDropMenu}
                        type={fieldtype}
                        fieldName={fieldName}
                        viewAttr={viewAttr}
                        viewtype={isdetail ? "1" : "0"}
                        //disabledInput={disabledInput}
                        // title={label}
                        resize={false}
                        maxBrowerHeight={77}
                        hasAdvanceSerach={hasAdvanceSerach}
                        {...otherProps}
                        replaceDatas={bind.value?toJS(bind.valueObj):[]}
                        // valueObj={bind.valueObj.slice()}
                        scrollx={true}
                        emptyValueNotClear={true}
                        modalStyle={{ width: 850 }}
                        key={new Date().getTime()}
                        {...overBrowserProps}
                        onBeforeFocusCheck={(success)=>{
                            if (seclevelInfo=='field-9'&&!secretLevel) {// 存在密级字段才进行必填提醒
                                message.error(getLabel('530630','请先填写卡片密级！'));
                            } else {
                                success();
                            }
                        }}
                    />
                    <span className="editicon" style={{display:isDisplay}}><i className="icon-coms-edit" ></i></span>
                </div>
            </div>
        )
    }
}

//人力资源条件数据处理
export const spellResourceCondition = (datas) => {
    if (datas) {
        let value: string[] = [];
        datas.map((item) => {
            let candownload = item.canDownload == '是' ? '1' : '0';
            if (item.sharetype == "1") {
                value.push(`1_${item.relatedshare}_0_0_${candownload}`);
            } else if (item.sharetype == "2" || item.sharetype == "3") {
                value.push(`${item.sharetype}_${item.relatedshare}_0_${item.seclevel.replace('-', '|@|')}_${candownload}`);
            } else if (item.sharetype == "4") {
                value.push(`4_${item.relatedshare}_${item.rolelevel}_${item.seclevel.replace('-', '|@|')}_${candownload}`);
            } else if (item.sharetype == "5") {
                value.push(`5_0_0_${item.seclevel.replace('-', '|@|')}_${candownload}`);
            } else if (item.sharetype == "6") {
                if (item.joblevel == '2') {
                    value.push(`6_${item.relatedshare}_0_2|@|2_${candownload}`);
                } else {
                    value.push(`6_${item.relatedshare}_0_${item.joblevel}|@|${item.jobfield}_${candownload}`)
                }
            }
        });
        return value.join('~');
    }
    return '';
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/cell-field/browser-element/Browser.tsx